// extracted by mini-css-extract-plugin
export var accentColor = "#84bae5";
export var categoryBorderColor = "#bbc8d5";
export var disableRipple = "false";
export var mainColor = "#f3a8bb";
export var mainContrast = "rgba(0,0,0,.87)";
export var panelBorderColor = "#bbc8d5";
export var secondaryColor = "#bbc8d5";
export var secondaryContrast = "rgba(0,0,0,.87)";